/**
 * The application version shown in the sidebar.
 *
 * Injected at build time by vite.config.ts from the **root** package.json, so
 * there is one number to bump and no request to make — the login page and the
 * public reader could show it too without an API round trip. The web bundle and
 * the API ship in a single image, so a version baked into the bundle cannot
 * disagree with the server it came from.
 *
 * Declared rather than imported: `define` performs a textual substitution at
 * build time, so this identifier never exists at runtime. There is deliberately
 * no `?? "unknown"` fallback — a missing substitution should fail loudly in
 * version.test.ts rather than quietly render a plausible lie in the corner.
 */
declare const __APP_VERSION__: string;

export const APP_VERSION: string = __APP_VERSION__;
